var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
export var is2DArray = function (array) {
    return Array.isArray(array) && Array.isArray(array[0]);
};
export var transformSideNavItems = function (children) { return (is2DArray(children) ? children : [children]); };
export var transformTopNavItems = function (items) {
    if (is2DArray(items)) {
        return items;
    }
    var aggregation = items.reduce(function (acc, item) {
        if (item.promoImg || item.html) {
            return __assign(__assign({}, acc), { promo: __spread(acc.promo, [item]) });
        }
        return __assign(__assign({}, acc), { menu: __spread(acc.menu, [
                __assign(__assign({}, item), { children: [__spread(item.children)] }),
            ]) });
    }, { menu: [], promo: [] });
    return aggregation.promo.length > 0
        ? [__spread(aggregation.menu), __spread(aggregation.promo)]
        : [__spread(aggregation.menu)];
};
